<template>
  <div class="campo-horarios">
    <v-row dense>
      <v-col
        v-for="(recurso, index) in recursos"
        :key="recurso.id || index"
        cols="12"
      >
        <div class="horario-item">
          <v-row dense align="center">
            <v-col cols="12" sm="2" md="1" class="d-flex align-center">
              <v-chip small label outlined color="primary">
                {{ index + 1 }}
              </v-chip>
            </v-col>

            <v-col cols="12" sm="10" :md="exibirTolerancias ? 4 : 8">
              <CampoHorario
                :payload="recurso.horario"
                label="Horario"
                :name="'CompHorario_horario' + (index + 1)"
                :obrigatorio="false"
                :clearable="true"
                @date="onHorarioChange(index, $event)"
              />
            </v-col>

            <v-col v-if="exibirTolerancias" cols="12" sm="6" md="3">
              <v-text-field
                :value="recurso.toleranciaAnteriorMinutos"
                :label="$t('ToleranciaAnteriorMinutos')"
                :name="'CompHorario_toleranciaAnterior' + (index + 1)"
                type="number"
                min="0"
                step="1"
                inputmode="numeric"
                hide-details="auto"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
                @input="
                  onToleranciaInput(index, 'toleranciaAnteriorMinutos', $event)
                "
              >
                <template v-slot:append>min</template>
              </v-text-field>
            </v-col>

            <v-col v-if="exibirTolerancias" cols="12" sm="6" md="3">
              <v-text-field
                :value="recurso.toleranciaPosteriorMinutos"
                :label="$t('ToleranciaPosteriorMinutos')"
                :name="'CompHorario_toleranciaPosterior' + (index + 1)"
                type="number"
                min="0"
                step="1"
                inputmode="numeric"
                hide-details="auto"
                class="
                  input-style
                  font-size-input
                  text-light-input
                  placeholder-light
                  input-icon
                "
                dense
                flat
                filled
                solo
                @input="
                  onToleranciaInput(index, 'toleranciaPosteriorMinutos', $event)
                "
              >
                <template v-slot:append>min</template>
              </v-text-field>
            </v-col>

            <v-col
              cols="12"
              sm="12"
              :md="exibirTolerancias ? 1 : 3"
              class="d-flex justify-end align-center"
            >
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    icon
                    small
                    color="red"
                    :disabled="recursosCount <= 1"
                    v-bind="attrs"
                    v-on="on"
                    @click="removeRecurso(index)"
                  >
                    <v-icon small>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </template>
                <span>{{ $t("Remover") }}</span>
              </v-tooltip>
            </v-col>
          </v-row>
        </div>
      </v-col>

      <v-col cols="12">
        <v-btn
          small
          text
          color="primary"
          class="text-none px-2"
          @click="addRecurso"
        >
          <v-icon left small>mdi-plus-circle</v-icon>
          {{ adicionarHorarioLabel }}
        </v-btn>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CampoHorario from "@/components/base/proprios/CampoHorario.vue";

export default {
  name: "CampoHorarios",

  components: { CampoHorario },

  props: {
    payload: {
      type: Array,
      required: false,
      default() {
        return [{ horario: "" }];
      },
    },
    exibirTolerancias: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      recursos: this.normalizeRecursos(this.payload),
    };
  },

  computed: {
    recursosCount() {
      return this.recursos.length;
    },

    adicionarHorarioLabel() {
      return `${this.$t("Adicionar")} ${String(
        this.$t("Horario")
      ).toLowerCase()}`;
    },
  },

  watch: {
    payload(val) {
      this.recursos = this.normalizeRecursos(val);
    },
  },

  mounted() {
    this.emitRecursos();
  },

  methods: {
    createEmptyRecurso() {
      return {
        horario: "",
        toleranciaAnteriorMinutos: null,
        toleranciaPosteriorMinutos: null,
      };
    },

    normalizeRecursos(payload) {
      const lista = Array.isArray(payload) && payload.length ? payload : [{}];
      return lista.map((item) => ({
        ...this.createEmptyRecurso(),
        ...(item || {}),
        horario: this.formatedHorario(item && item.horario),
        toleranciaAnteriorMinutos: this.normalizeInteger(
          item && item.toleranciaAnteriorMinutos
        ),
        toleranciaPosteriorMinutos: this.normalizeInteger(
          item && item.toleranciaPosteriorMinutos
        ),
      }));
    },

    onHorarioChange(index, value) {
      this.$set(this.recursos, index, {
        ...this.recursos[index],
        horario: value,
      });
      this.emitRecursos();
    },

    onToleranciaInput(index, field, value) {
      this.$set(this.recursos, index, {
        ...this.recursos[index],
        [field]: this.normalizeInteger(value),
      });
      this.emitRecursos();
    },

    addRecurso() {
      this.recursos.push(this.createEmptyRecurso());
      this.emitRecursos();
    },

    removeRecurso(index) {
      if (this.recursosCount <= 1) {
        return;
      }
      this.recursos.splice(index, 1);
      this.emitRecursos();
    },

    emitRecursos() {
      const recursosPayload = this.recursos.map((item) => ({
        ...item,
        horario: this.formatedHorario(item && item.horario),
        toleranciaAnteriorMinutos: this.normalizeInteger(
          item && item.toleranciaAnteriorMinutos
        ),
        toleranciaPosteriorMinutos: this.normalizeInteger(
          item && item.toleranciaPosteriorMinutos
        ),
      }));
      this.$emit("recursos", recursosPayload);
    },

    normalizeInteger(value) {
      if (value === null || value === undefined || value === "") {
        return null;
      }
      const number = Number(value);
      if (Number.isNaN(number)) {
        return null;
      }
      return Math.max(0, Math.floor(number));
    },

    formatedHorario(value) {
      const raw = String(value || "").trim();
      if (!raw) {
        return null;
      }

      let time = raw;
      if (raw.length === 19 && raw.includes("T")) {
        time = raw.substring(11, 19);
      }

      const match = time.match(/^(\d{2}):(\d{2})(?::(\d{2}))?$/);
      if (!match) {
        return null;
      }

      const hora = Number(match[1]);
      const min = Number(match[2]);
      const seg = match[3] === undefined ? 0 : Number(match[3]);

      if (
        Number.isNaN(hora) ||
        Number.isNaN(min) ||
        Number.isNaN(seg) ||
        hora < 0 ||
        hora > 23 ||
        min < 0 ||
        min > 59 ||
        seg < 0 ||
        seg > 59
      ) {
        return null;
      }

      return `${match[1]}:${match[2]}:${String(seg).padStart(2, "0")}`;
    },
  },
};
</script>

<style scoped>
.campo-horarios {
  width: 100%;
}

.horario-item {
  border: 1px solid rgba(103, 116, 142, 0.18);
  border-radius: 6px;
  padding: 8px;
}
</style>
